// ********
// Quantity Counter
// ********

const addRemoveQuantityCounterButton = (element, toggle) => {
  const parentElem = element.closest('.quantity-counter');
  const inputElem = parentElem.querySelector('.quantity-counter__input');
  const minusButton = parentElem.querySelector('.quantity-counter__button--remove');
  const addButton = parentElem.querySelector('.quantity-counter__button--add');
  let currentVal = parseInt(inputElem.value, 10);
  const maxValue = parseInt(inputElem.getAttribute('max'), 10);

  if (!toggle && currentVal <= 1) return;

  if (toggle && maxValue && currentVal >= maxValue) {
    addButton.classList.add('is-disabled');
    addButton.setAttribute('aria-disabled', 'true');
    return;
  }

  if (currentVal >= 1) {
    // eslint-disable-next-line
    inputElem.value = toggle ? ++currentVal : --currentVal;
    minusButton.classList.remove('is-disabled');
    minusButton.setAttribute('aria-disabled', 'false');
  }

  if (currentVal === 1) {
    minusButton.classList.add('is-disabled');
    minusButton.setAttribute('aria-disabled', 'true');
  }

  if (!toggle && maxValue && currentVal < maxValue) {
    addButton.classList.remove('is-disabled');
    addButton.setAttribute('aria-disabled', 'false');
  }

  // Disable add when value reached max
  if (toggle && maxValue && currentVal >= maxValue) {
    addButton.classList.add('is-disabled');
    addButton.setAttribute('aria-disabled', 'true');
  }

  inputElem.dispatchEvent(new Event('change', { bubbles: true }));
};

attachEvent('.quantity-counter__button--add', 'click', (ev) => {
  addRemoveQuantityCounterButton(ev.target, true);
});

attachEvent('.quantity-counter__button--remove', 'click', (ev) => {
  addRemoveQuantityCounterButton(ev.target, false);
});

// ********
// Counter Disabled Class
// ********

const quantityCounterEle = document.querySelectorAll('.quantity-counter');

if (quantityCounterEle.length > 0) {
  quantityCounterEle.forEach((el) => {
    const inputElem = el.querySelector('.quantity-counter__input');
    const minusButton = el.querySelector('.quantity-counter__button--remove');
    const addButton = el.querySelector('.quantity-counter__button--add');
    const currentVal = parseInt(inputElem.value, 10);
    const maxValue = parseInt(inputElem.getAttribute('max'), 10);

    if (currentVal > 1) {
      minusButton.classList.remove('is-disabled');
      minusButton.setAttribute('aria-disabled', 'false');
    }

    if (maxValue && currentVal >= maxValue) {
      addButton.classList.add('is-disabled');
      addButton.setAttribute('aria-disabled', 'true');
    }
  });
}
